import React from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FiMic, FiArrowRight } from 'react-icons/fi';
import './Hero.css';
import squirrelLeft from '../assets/Leftsquirrel.png';
import squirrelRight from '../assets/Rightsquirrel.png';
// import Title from '../assets/Title.png'; // Logo now in page header
// import Cloud from '../assets/CLOUD.png'; // Commented out for now


const Hero = () => {
  const navigate = useNavigate();

  // Floating letter blocks data
  const floatingBlocks = [
    { letter: 'U', x: '15%', y: '20%', delay: 0, rotate: -12 },
    { letter: 'N', x: '22%', y: '65%', delay: 0.1, rotate: 8 },
    { letter: 'S', x: '78%', y: '25%', delay: 0.2, rotate: 15 },
    { letter: 'C', x: '80%', y: '70%', delay: 0.3, rotate: -8 },
    { letter: 'R', x: '12%', y: '45%', delay: 0.4, rotate: 5 },
    { letter: 'A', x: '85%', y: '48%', delay: 0.5, rotate: -10 },
  ];

  return (
    <section className="hero">
      {/* Floating scrabble tiles */}
      <div className="floating-letters">
        {floatingBlocks.map((block, index) => (
          <motion.div
            key={block.letter}
            className="floating-block"
            style={{
              left: block.x,
              top: block.y,
              rotate: block.rotate,
            }}
            initial={{ opacity: 0 }}
            animate={{
              opacity: 1,
              y: [0, -15, 0],
              rotate: [block.rotate, block.rotate + 5, block.rotate],
            }}
            transition={{
              delay: block.delay,
              duration: 0.5,
              y: { repeat: Infinity, duration: 4 + index * 0.5, ease: "easeInOut" },
              rotate: { repeat: Infinity, duration: 5 + index * 0.3, ease: "easeInOut" },
            }}
          >
            {block.letter}
          </motion.div>
        ))}
      </div>

      {/* Bottom-left squirrel */}
      <motion.div
        className="squirrel-left"
        initial={{ opacity: 0, x: -50 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ delay: 0.5, duration: 0.6 }}
      >
        <img src={squirrelLeft} alt="Decorative squirrel" className="squirrel-img" />
      </motion.div>

      <motion.div
        className="squirrel-top-right"
        initial={{ opacity: 0, y: -30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.5, duration: 0.6 }}
      >
        <img src={squirrelRight} alt="Decorative squirrel" className="squirrel-img" />
      </motion.div>

{/* Logo removed - already in page header */}


      {/* Main content */}
      <div className="hero-content">
        {/* Cloud background - commented out for now
        <motion.img
          src={Cloud}
          alt=""
          className="hero-cloud"
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.8 }}
        />
        */}

        {/* Main heading */}
        <motion.h1
          className="hero-title"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2 }}
        >
          SPEAK FIRST.
          <br />
          <span className="title-accent">STRUCTURE LATER.</span>
        </motion.h1>

        {/* Subtitle */}
        <motion.p
          className="hero-subtitle"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3 }}
        >
          Turn your rambling thoughts into clear, organized ideas.
          <br />
          Just talk — we'll handle the rest.
        </motion.p>

        {/* CTA Buttons */}
        <motion.div
          className="hero-actions"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.4 }}
        >
          <motion.button
            className="btn-cta primary"
            onClick={() => navigate('/record')}
            whileHover={{ scale: 1.03, y: -2 }}
            whileTap={{ scale: 0.98 }}
          >
            <FiMic />
            <span>Start Rambling</span>
            <FiArrowRight className="arrow-icon" />
          </motion.button>
        </motion.div>
      </div>
    </section>
  );
};

export default Hero;
